import { useLocation } from "react-router-dom";

const ContentWrapper = ({ children, style }) => {
  const url = useLocation();

  return url.pathname === "/crm/actions" ||
    url.pathname.includes("/project/edit/") ? (
    <div className="content-wrapper kanban" style={{ background: "#f4f6f9" }}>{children}</div>
  ) : (
    <div className="content-wrapper" style={{ background: "#f4f6f9", ...style }}>{children}</div>
  );
};

export default ContentWrapper;
